import { useEffect, useId, useState } from "react";

type ConnectedPickerPlacement = "bottom" | "top";

export function useConnectedPickerPlacement(isOpen: boolean): {
  inputClassName: string | undefined;
  popupClassName: string;
} {
  const id = useId();
  const popupClassName = `connected-picker-${id.replaceAll(":", "")}`;
  const [placement, setPlacement] = useState<ConnectedPickerPlacement>("bottom");

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    let observer: MutationObserver | undefined;
    const frame = requestAnimationFrame(() => {
      const popup = document.getElementsByClassName(popupClassName).item(0);
      if (!popup) {
        return;
      }

      const syncPlacement = () => {
        setPlacement(
          popup.classList.contains("ant-picker-dropdown-placement-topLeft") ||
            popup.classList.contains("ant-picker-dropdown-placement-topRight")
            ? "top"
            : "bottom",
        );
      };

      // Ant can realign the popup after rendering, so keep its resolved class in sync while open.
      observer = new MutationObserver(syncPlacement);
      observer.observe(popup, {
        attributeFilter: ["class"],
        attributes: true,
      });
      syncPlacement();
    });

    return () => {
      cancelAnimationFrame(frame);
      if (observer) {
        observer.disconnect();
      }
    };
  }, [isOpen, popupClassName]);

  return {
    inputClassName: isOpen ? `picker-open-${placement}` : undefined,
    popupClassName,
  };
}
